import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import EditPhoneNumber from './EditPhoneNumber';

const AddPhoneNumber = ({ isOpen, onCancel,onConfirm, phone }) => {
  return (
    <Modal isOpen={isOpen} style={{ maxWidth: '900px' }}>
      <ModalHeader>Edit Number</ModalHeader>
      <ModalBody>
        <EditPhoneNumber phone={phone} />
      </ModalBody>
      <ModalFooter>
        <Button outline onClick={onCancel}>
          Cancel
        </Button>
        <Button color="primary" onClick={onConfirm}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddPhoneNumber;
